import { Navigate, createFileRoute } from '@tanstack/react-router';

import { ShigoPermission } from '../features/auth/permissions';
import { useShigoPermissions } from '../features/auth/useShigoPermissions';

export const Route = createFileRoute('/demand/')({
  component: DemandIndexRoute,
});

function DemandIndexRoute() {
  const { can } = useShigoPermissions();
  if (can(ShigoPermission.DemandPartnersRead)) {
    return <Navigate to="/demand/owners" replace />;
  }
  if (can(ShigoPermission.DemandIntegrationsRead)) {
    return <Navigate to="/demand/integrations" replace />;
  }
  return <Navigate to="/demand/deals" replace />;
}
